import React from "react";
import { Bar } from "react-chartjs-2";
import { CircularProgress, Grid, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import { BookingReportOptions } from "./RideData";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BookingReportStatus(props) {
  return (
    <Grid item container mt={1} columnSpacing={7} mb={4}>
      <Grid item xs={12} sm={12} md={4}>
        <div className="reportChart">
          <div className="reportsDatePicker">
            <Typography className="fontNormal font18 colorBlack" pt={1}>
              {props?.titleData.doughnutTitle}
            </Typography>
          </div>

          <div className="chartMinHeight revenueCountStyle">
            {props?.isLoadingRideAnalytic ? (
              <CircularProgress />
            ) : props?.rideAnalytic?.datasets?.length > 0 ? (
              <Grid item>
                <img src={props?.countSrc} />
                <Typography className="textAlign font36 fontMedium colorBlue">
                  {props?.title === 'Revenue' && '₹'}{parseInt(props?.rideAnalytic?.datasets[0]?.total)}
                </Typography>
              </Grid>
            ) : (
              <CommonNoDataFound />
            )}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={8}>
        <div className="reportChart">
          <Typography className="fontNormal font18 colorBlack" pt={1}>
            {props?.titleData.barTitle}
          </Typography>
          <div className="chartMinHeight">
            {props?.loadingAnalytic ? (
              <CircularProgress />
            ) : props?.rideAnalytic?.labels?.length > 0 ? (
              <Bar
                id="bookingReportChart"
                options={BookingReportOptions}
                data={props?.rideAnalytic}
              />
            ) : (
              <CommonNoDataFound />
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
